/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const uploadCandidateFileDataSchema = z.object({
	file: z.unknown(),
})

export type UploadCandidateFileDataSchema = z.infer<typeof uploadCandidateFileDataSchema>
